var map = {
	"./content/cdn.webp": 1220,
	"./content/colocation.webp": 1221,
	"./content/ddos.webp": 1222,
	"./content/dedicated-server.webp": 1223,
	"./content/dns.webp": 1224,
	"./content/firewall.webp": 1225,
	"./content/graphics-server.webp": 1226,
	"./content/local-storage.webp": 1227,
	"./content/object-storage.webp": 1228,
	"./content/vpc.webp": 1229,
	"./content/vps.webp": 1230,
	"./content/waf.webp": 1231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1286;